import { memo } from 'react';

import { TryCanvasPopover } from '~/components/TryCanvasPopover/TryCanvasPopover';
import { useTryCanvasPopoverState } from '~/components/TryCanvasPopover/useTryCanvasPopoverState';

export const TryCanvasPopoverWrapper = memo(() => {
  const { visible, boardId, handleClose } = useTryCanvasPopoverState();

  if (!visible) {
    return null;
  }

  return <TryCanvasPopover boardId={boardId} onClose={handleClose} />;
});

TryCanvasPopoverWrapper.displayName = 'TryCanvasPopoverWrapper';
